module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_dp-f _fdrt-r",
    staticStyle: {
      "padding-top": "60px"
    }
  }, [_c('div', {
    staticClass: "_dp-n _dp-b-sm _pst-f _pdh-16px _pdv-32px _bgcl-neutral-100 _w-256px _ovf-at",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-getting-start",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Introduction'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            เกี่ยวกับ Biomatic\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Installation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            วิธีติดตั้ง\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'GettingStart'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            การใช้งาน ⭐️\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-atomic",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Alignment\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Background\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Border\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Box Position\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Box Size\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicColor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Color\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Cursor\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicDisplay'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Display\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Float\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicMargin'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Margin\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicObjectFit'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Object Fit\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOpacity'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Opacity\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOverflow'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Overflow\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Padding\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicTypography'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Typography\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Z-Index\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-components",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentAccordion'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Accordion\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Breadcrumb\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentButton'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Button\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentCard'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Card\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentForm'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Form\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Message\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Progress\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentTooltip'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Tooltip\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-layouts",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutContainer'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Container\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutResponsiveGrid'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Responsive Grid\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-utilities",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityAnimation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Animation\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityRise'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Rise\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "_pdh-16px _pdh-64px-sm _pdv-0px _mgl-0px _mgl-256px-sm _f-1 _ovf-at"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('router-view', {
    staticStyle: {
      "max-width": "800px"
    }
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fs-5",
    attrs: {
      "for": "accordion-getting-start"
    }
  }, [_c('strong', [_vm._v("Getting Start")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-atomic"
    }
  }, [_c('strong', [_vm._v("Atomic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-components"
    }
  }, [_c('strong', [_vm._v("Components")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-layouts"
    }
  }, [_c('strong', [_vm._v("Layouts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-utilities"
    }
  }, [_c('strong', [_vm._v("Utilities")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c911ec8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/document/Document.vue
// module id = 128
// module chunks = 0